import { XHtml } from "@/components/xhtml";
import { HeroSection } from "./components/hero-section";
import { CategoryPageProps } from "@/pages/category-page/types";
import { NavLinkSection } from "./components/nav-link-section";
import { Heading, Paragraph } from "@digdir/designsystemet-react";


const themeClasses = {
    Blue: "bg-brand text-white",
    Red: "bg-brand-support-pink text-brand-support-blue",
    Gray: "bg-brand-detail-gray text-brand-detail-blue ",
} as const;

export function CategoryPage({
    imageUrl,
    imageAlt,
    categoryTitle,
    heading,
    headerColor = "Blue",
    hero = [],
    navLinks = [],
    mainIntro,
    mainBody,
}: CategoryPageProps) {

    const theme = themeClasses[headerColor];

    return (
        <div className="w-full max-w-[1470px] mx-auto ">
            <div className="relative mt-10 max-h-[500px] overflow-hidden">
                {imageUrl && (
                    <figure className="mb-0 w-full aspect-[66/25]">
                        <img
                            src={imageUrl}
                            alt={imageAlt || categoryTitle || ""}
                            className="w-full h-full object-cover"
                        />
                    </figure>
                )}

                {categoryTitle && (
                    <div className="absolute inset-0">
                        <div className={'absolute bottom-0 left-1/2 -translate-x-1/2 px-4 py-2 bg-brand-support-blue text-white'}>
                            <Heading level={3} data-size="xs" className="!mb-0 text-white">{categoryTitle}</Heading>
                        </div>
                    </div>
                )}
            </div>

            <header className={`text-center py-5 ${theme}`}>
                <Heading level={1} data-size="xl" className="!mb-0">{heading}</Heading>
            </header>

            <HeroSection headerColor={headerColor} hero={hero} />

            <section className="layout-container flex flex-col gap-10 pt-10">
                {navLinks?.length && <NavLinkSection navLinks={navLinks} />}
                {mainIntro && <Paragraph data-size="lg" className="!mb-0">{mainIntro}</Paragraph>}
                {mainBody && <XHtml xhtmlString={mainBody} />}
            </section>
        </div>
    );
};

